import { ResponseGetInputsStoreProducts_storeId_ } from "@CommonApi/inputs/store-products/_storeId_";
import { RefObject, useRef, useState } from "react";
import { useApi } from "src/api";
import { Search } from "src/elements";
import { useDebounceEffect } from "src/hooks/useDebounceEffect";

interface Props {
  storeId: number;
  page: number;
  size: number;
  refSearch: RefObject<string>;
  setResponse: (
    state:
      | ResponseGetInputsStoreProducts_storeId_
      | Promise<ResponseGetInputsStoreProducts_storeId_ | null>
      | null
      | undefined,
  ) => void;
}

export const ProductsSearcher = ({ storeId, page, size, refSearch, setResponse }: Props) => {
  const { getStoreProductsApi } = useApi();

  const [search, _setSearch] = useState("");
  const refFirstRun = useRef(true);

  useDebounceEffect(
    () => {
      if (refFirstRun.current) {
        refFirstRun.current = false;
      } else {
        setResponse(getStoreProductsApi({ storeId, page, size, search }));
      }
    },
    [search],
    600,
  );

  const setSearch = (search: string) => {
    _setSearch(search);
    refSearch.current = search;
  };

  return (
    <Search width="200px" search={search} setSearch={setSearch} placeholder="Search products" />
  );
};
